import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment';
import * as _ from 'lodash';
import {JOB_REQUEST_STATUS, MARKETS, REFERRAL_SOURCES} from '../constants';
import { getCurrencySymbol } from '@angular/common';
import {MatSnackBar} from "@angular/material/snack-bar";
import {ErrorsComponent} from "../../widgets/errors/errors.component";
import {
    WrenchBottomSheetFooterComponent
} from "../../wrench-bottom-sheet/components/wrench-bottom-sheet-footer/wrench-bottom-sheet-footer.component";
import {MatBottomSheetRef} from "@angular/material/bottom-sheet";
import {WrenchBottomSheetService} from "../../wrench-bottom-sheet/wrench-bottom-sheet.service";

@Injectable()
export class UtilitiesService {

    constructor(private snackBar: MatSnackBar,
                private wrenchBottomSheetService: WrenchBottomSheetService) {}

    public throwSnackBar(message: string, showPhone?: boolean) {
        const phone: string = $localize` Call 1-844-997-3624 for assistance.`;
        this.snackBar.open(message + (showPhone ? phone : ''), 'Dismiss', {duration: UtilitiesService.seconds(5)});
    }

    public throwBasicSheet(header: string, message: string, showPhone?: boolean): void {
        this.wrenchBottomSheetService.open(ErrorsComponent, null, WrenchBottomSheetFooterComponent)
            .subscribe((bottomSheetRef: MatBottomSheetRef) => {
                bottomSheetRef.instance.content.errorHeader = header;
                bottomSheetRef.instance.content.errorMessage = message;
                bottomSheetRef.instance.content.showPhone = showPhone;

                bottomSheetRef.instance.footer.primaryButtonText = "OK";
                bottomSheetRef.instance.footer.primaryButtonClick.subscribe(() => bottomSheetRef.dismiss());
            });
    } // showMixedServicesModal()

    public static mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    public static ZIP_REGEXP = /^\d+$/;
    private storage: any = null;

    private static reallyIsNaN(x: any) {
        return x !== x;

    } // reallyIsNaN()

    /**
     * checks for null, typeof "undefined", empty string, NaN, empty array, empty object
     * @param value - the value to check
     */
    public static isEmpty(value: any): boolean {
        return !(value !== null
            && typeof value !== 'undefined'
            && value != ''
            && value != 'null'
            && !UtilitiesService.reallyIsNaN(value)
            && !(value.constructor === Array && value.length == 0)
            && !(typeof value == 'object' && Object.keys(value).length == 0));

    } // isEmpty()

    public static isNotEmpty(value: any): boolean {
        return !UtilitiesService.isEmpty(value);
    }

    static highlightSelectedMatTab(tabId: any, origin: any, selected: any) {
        if (origin != null) {
            let previousTab: any = document.getElementById(tabId);
            if (previousTab) {
                previousTab = previousTab.getElementsByClassName('mat-tab-label')[origin];
                previousTab.classList.remove('tab-selected');
            }

            let selectedTab: any = document.getElementById(tabId);
            if (selectedTab) {
                selectedTab = selectedTab.getElementsByClassName('mat-tab-label')[selected];
                selectedTab.classList.add('tab-selected');
            }
        } else if (origin == null) {
            let selectedTab: any = document.getElementById(tabId);
            if (selectedTab) {
                selectedTab = selectedTab.getElementsByClassName('mat-tab-label')[selected];
                selectedTab.classList.add('tab-selected');
            }
        }
    } // highlightSelectedMatTab()

    static toggleScrolling(status: any) {
        let body = document.getElementsByTagName('body')[0];

        let appRoot = document.getElementsByTagName('app-root')[0];

        if (!status && body) {
            body.classList.add('modal-open');
        } else if (body){
            body.classList.remove('modal-open');
        }

        if (!status && appRoot) {
            appRoot.classList.add('modal-open-mobile');
        } else if (appRoot){
            appRoot.classList.remove('modal-open-mobile');
        }
    } // toggleScrolling()

    static hideHeaderFooterForPrint() {
        let header = document.getElementById('header');
        if (header) {
            header.classList.add('display-none');
        }

        let footer = document.getElementById('footer');
        if (footer) {
            footer.classList.add('display-none');
        }

        let bannerContainer = document.getElementById('bannerContainer');
        if (bannerContainer) {
            bannerContainer.classList.add('display-none');
        }

        let pageWrapper = document.getElementById('page-wrapper');
        if (pageWrapper) {
            pageWrapper.style.minHeight = 'calc(100vh)';
            pageWrapper.style.paddingTop = '0px';
        }
    } // hideHeaderFooterForPrint()

    static showHeaderFooterPostPrint() {
        let header = document.getElementById('header');
        if (header) {
            header.classList.remove('display-none');
        }

        let footer = document.getElementById('footer');
        if (footer) {
            footer.classList.remove('display-none');
        }

        let bannerContainer = document.getElementById('bannerContainer');
        if (bannerContainer) {
            bannerContainer.classList.remove('display-none');
        }

        let pageWrapper = document.getElementById('page-wrapper');
        if (pageWrapper) {
            pageWrapper.removeAttribute('style');
        }
    } // showHeaderFooterPostPrint()

    // for logging things to the console in dev only
    static consoleLog(...logs: any) {
        if (!environment.production) {
            // tslint:disable-next-line:no-console
            console.trace();
            console.log(...logs);
        }

    } // consoleLog()

    static downloadPdf(response: any) {
        let fileBlob = response.body;
        let blob = new Blob([fileBlob], {
            type: 'application/pdf'
        });
        return blob;
    } // downloadPdf()

    static deepCopy(source: Object): any {
        return JSON.parse(JSON.stringify(source));
    }

    static isReferrerFleet() {
        return document.referrer.search(/\/fleet\/|\/fleet$/) >= 0;
    } // isReferrerFleet()

    static hasFleetParam(): boolean {
        return new URLSearchParams(document.location.search).get('fleet') !== null;
    }

    /**
     * checks for null, typeof "undefined", empty string, NaN, empty array, empty object
     * @param value - the value to check
     * @deprecated
     */
    public isEmpty(value: any): boolean {
        return !(value !== null
        && typeof value !== 'undefined'
        && value != ''
        && value != 'null'
        && !UtilitiesService.reallyIsNaN(value)
        && !(value.constructor === Array && value.length == 0)
        && !(typeof value == 'object' && Object.keys(value).length == 0));

    } // isEmpty()

    /**
     * negation of this.isEmpty
     * @param value - the value to be checked
     * @deprecated
     */
    public isNotEmpty(value: any): boolean {
        return !this.isEmpty(value);
    }

    /**
     * converts a string of type "yyyy-MM-dd hh:mm:ss" to a timestamp
     * this prevents any changing of date based on timezones
     *
     * @param dateTimeString
     * @deprecated
     */
    public timestampFromDate(dateTimeString: any) {
        let date = new Date();
        date.setFullYear(dateTimeString.substring(0, 4), parseInt(dateTimeString.substring(5, 7), 10) - 1, dateTimeString.substring(8, 10));
        date.setHours(dateTimeString.substring(11, 13), dateTimeString.substring(14, 16), dateTimeString.substring(17, 19));
        date.setMilliseconds(0);
        return date.getTime();

    } // timestampFromDate()

    /**
     * converts a string of type "yyyy-MM-dd hh:mm:ss" to a timestamp
     * this prevents any changing of date based on timezones
     *
     * @param dateTimeString
     */
    public static timestampFromDate(dateTimeString: any) {
        let date = new Date();
        date.setFullYear(dateTimeString.substring(0, 4), parseInt(dateTimeString.substring(5, 7), 10) - 1, dateTimeString.substring(8, 10));
        date.setHours(dateTimeString.substring(11, 13), dateTimeString.substring(14, 16), dateTimeString.substring(17, 19));
        date.setMilliseconds(0);
        return date.getTime();

    } // timestampFromDate()

    /**
     * converts a string of type "yyyy-MM-dd hh:mm:ss" to a timestamp
     * this prevents any changing of date based on timezones
     *
     * @param dateTimeString
     * @deprecated
     */
    public dateFromString(dateTimeString: any) {
        let date = new Date();
        date.setFullYear(dateTimeString.substring(0, 4), parseInt(dateTimeString.substring(5, 7), 10) - 1, dateTimeString.substring(8, 10));
        date.setHours(dateTimeString.substring(11, 13), dateTimeString.substring(14, 16), dateTimeString.substring(17, 19));
        date.setMilliseconds(0);
        return date;

    } // dateFromString()

    public static dateFromString(dateTimeString: any) {
        let date = new Date();
        date.setFullYear(dateTimeString.substring(0, 4), parseInt(dateTimeString.substring(5, 7), 10) - 1, dateTimeString.substring(8, 10));
        date.setHours(dateTimeString.substring(11, 13), dateTimeString.substring(14, 16), dateTimeString.substring(17, 19));
        date.setMilliseconds(0);
        return date;

    } // dateFromString()

    /**
     * converts a timestamp to a string of type "yyyy-MM-dd hh:mm:ss"
     *
     * @param timestamp
     * @deprecated
     */
    public dateFromTimestamp(timestamp: any) {
        let date = new Date(timestamp);
        let month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        let day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate();
        let hours = date.getHours() < 10 ? '0' + date.getHours().toString() : date.getHours();
        let mins = date.getMinutes() < 10 ? '0' + date.getMinutes().toString() : date.getMinutes();
        let sec = date.getSeconds() < 10 ? '0' + date.getSeconds().toString() : date.getSeconds();
        return date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + mins + ':' + sec;

    } // dateFromTimestamp()

    public static dateFromTimestamp(timestamp: any) {
        let date = new Date(timestamp);
        let month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        let day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate();
        let hours = date.getHours() < 10 ? '0' + date.getHours().toString() : date.getHours();
        let mins = date.getMinutes() < 10 ? '0' + date.getMinutes().toString() : date.getMinutes();
        let sec = date.getSeconds() < 10 ? '0' + date.getSeconds().toString() : date.getSeconds();
        return date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + mins + ':' + sec;

    } // dateFromTimestamp()

    /**
     * returns string from Date object
     *
     * @param date
     */
    public static dateStringFromDate(date: Date): string {
        if (!(date instanceof Date)) {
            return null;
        }
        const month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1).toString() : (date.getMonth() + 1).toString();
        const day = date.getDate() < 10 ? '0' + date.getDate().toString() : date.getDate();
        const hours = date.getHours() < 10 ? '0' + date.getHours().toString() : date.getHours();
        const mins = date.getMinutes() < 10 ? '0' + date.getMinutes().toString() : date.getMinutes();
        const sec = date.getSeconds() < 10 ? '0' + date.getSeconds().toString() : date.getSeconds();
        return date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + mins + ':' + sec;

    } // dateStringFromDate()

    /**
     * sets the hours, minutes, and seconds of a date to 0
     * @param date
     * @deprecated
     */
    public setDateToMidnight(date: any) {
        if (date instanceof Date) {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
        }
        return date;
    } // setDateToMidnight()

    public static setDateToMidnight(date: any) {
        if (date instanceof Date) {
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
        }
        return date;

    } // setDateToMidnight()

    public static setDateToEndOfDay(date: any) {
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
        date.setMilliseconds(0);
        return date;
    } // setDateToEndOfDay()

    /**
     * @deprecated
     */
    public setDateToEndOfDay(date: any) {
        date.setHours(23);
        date.setMinutes(59);
        date.setSeconds(59);
        date.setMilliseconds(0);
        return date;
    } // setDateToEndOfDay()

    public getLocal(name: string) {
        if (this.isEmpty(this.storage)) {
            if (UtilitiesService.isStorageSupported(localStorage)) {
                this.storage = localStorage;
            } else if (UtilitiesService.isStorageSupported(sessionStorage)) {
                this.storage = sessionStorage;
            } else {
                return null;
            }
        }
        return this.storage.getItem(name);

    } // getLocal()

    public setLocal(name: string, value: any) {
        if (UtilitiesService.isEmpty(this.storage)) {
            if (UtilitiesService.isStorageSupported(localStorage)) {
                this.storage = localStorage;
            } else if (UtilitiesService.isStorageSupported(sessionStorage)) {
                this.storage = sessionStorage;
            } else {
                this.storage = this.tempStorage();
            }
        }
        this.storage.setItem(name, value);
    } // setLocal()

    public removeLocal(name: string) {
        if (UtilitiesService.isEmpty(this.storage)) {
            if (UtilitiesService.isStorageSupported(localStorage)) {
                this.storage = localStorage;
            } else if (UtilitiesService.isStorageSupported(sessionStorage)) {
                this.storage = sessionStorage;
            } else {
                this.storage = this.tempStorage();
            }
        }

        delete this.storage[name];
    } // removeLocal()

    private tempStorage() {
        let api = {setItem: null as any, getItem: null as any, clear: null as any};
        let store = {};
        api.setItem = function (name: any, value: any) {
            store[name] = value;
        };
        api.getItem = (name: any) => {
            return !this.isEmpty(store[name]) ? store[name] : null;
        };
        api.clear = function () {
            store = {};
        };
        return api;

    } // tempStorage()

    private static isStorageSupported(storage: any) {
        try {
            storage.setItem('test', '1');
            storage.removeItem('test');
            // localStorage.setItem('test', '1');
            // localStorage.removeItem('test');
            return true;
        } catch (error) {
            return false;
        }

    } // isStorageSupported()

    public clearStorage() {
        if (UtilitiesService.isEmpty(this.storage)) {
            if (UtilitiesService.isStorageSupported(localStorage)) {
                this.storage = localStorage;
            } else if (UtilitiesService.isStorageSupported(sessionStorage)) {
                this.storage = sessionStorage;
            } else {
                this.storage = this.tempStorage();
            }
        }

        this.storage.clear();
    } // clearStorage()

    public convertMarketStringToCode(marketString: any) {
        let marketCode = '';
        switch (marketString) {
            case 'dallas':
                marketCode = 'DAL';
                break;
            case 'las_vegas':
                marketCode = 'LAS';
                break;
            case 'los_angeles':
                marketCode = 'LAX';
                break;
            case 'orange_county':
                marketCode = 'SNA';
                break;
            case 'phoenix':
                marketCode = 'PHX';
                break;
            case 'portland':
                marketCode = 'PDX';
                break;
            case 'san_diego':
                marketCode = 'SAN';
                break;
            case 'seattle':
                marketCode = 'SEA';
                break;
            case 'austin':
                marketCode = 'AUS';
                break;
            case 'houston':
                marketCode = 'IAH';
                break;
            case 'sacramento':
                marketCode = 'SMF';
                break;
            case 'inland_empire':
                marketCode = 'ONT';
                break;
            case 'oakland':
                marketCode = 'OAK';
                break;
            case 'san_francisco':
                marketCode = 'SFO';
                break;
            case 'san_jose':
                marketCode = 'SJC';
                break;
            case 'chicago':
                marketCode = 'ORD';
                break;
            case 'san_antonio':
                marketCode = 'SAT';
                break;
            case 'denver':
                marketCode = 'DEN';
                break;
            case 'trenton':
                marketCode = 'TTN';
                break;
            case 'cleveland':
                marketCode = 'CLE';
                break;
            case 'kansas_city':
                marketCode = 'MCI';
                break;
            case 'st_louis':
                marketCode = 'STL';
                break;
            case 'philadelphia':
                marketCode = 'PHL';
                break;
            case 'washington_dc':
                marketCode = 'DCA';
                break;
            case 'detroit':
                marketCode = 'DTW';
                break;
            case 'pittsburgh':
                marketCode = 'PIT';
                break;
            case 'out_of_area':
                marketCode = 'OUT';
                break;
            default:
                break;
        }
        return marketCode;
    } // convertMarketStringToCode()

    public static convertMarketCodeToString(marketCode: any) {
        const marketDetails = MARKETS.find(m => m.code == marketCode);
        return marketDetails ? marketDetails.market : "";
    } // convertMarketCodeToString()

    public convertMarketStringToUpperCase(marketString: any) {
        const marketDetails = MARKETS.find(m => m.market == marketString);
        return marketDetails ? marketDetails.label : "";
    } // convertMarketStringToUpperCase()

    // this is duplicated in the hugo project
    // for creating a prospect on the fleet page
    public static randomString(length: number) {
        let text = '';
        let possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (let i = 0; i < length; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    } // randomString()

    /*
    *  Job Request Specific Functions
    */

    // only gets called for partner jobs
    private createNewJobRequestObjectWithService(service: any, jobRequest: any) {
        let tempJobRequest = _.cloneDeep(jobRequest);
        tempJobRequest.services = [service];
        tempJobRequest.serviceCodes = [service.code];
        // delete the notes to be added upon return to the quoteflow
        tempJobRequest.notes = '';
        tempJobRequest.partner = true;
        // quotes must be set to pricing when until further notice
        tempJobRequest.status = JOB_REQUEST_STATUS.PRICING;
        return tempJobRequest;
    }

    // maintain the original job request object for reference on failure
    separatePartnerJobRequests(jobRequest: any) {
        // split up partner jobs and send them as a list of jobRequests
        let tempServices = jobRequest.services.slice();
        let nonPartnerServices = [];
        let nonPartnerServiceCodes = [];
        let jobRequests = [];
        let nonPartnerNotes = '';
        for (let service of tempServices) {
            if (service.partner) {
                jobRequests.push(this.createNewJobRequestObjectWithService(service, jobRequest));
            } else {
                if (service.serviceCode === 100 || service.serviceCode === 1789) {
                    nonPartnerNotes = nonPartnerNotes ? `${nonPartnerNotes}\n${service.notes}` : service.notes;
                }
                nonPartnerServices.push(service);
                nonPartnerServiceCodes.push(service.code);
            }
        }
        // add the non partner services to the original jobRequest object
        if (!this.isEmpty(nonPartnerServices)) {
            let nonPartnerJobRequest = _.cloneDeep(jobRequest);
            nonPartnerJobRequest.services = nonPartnerServices;
            nonPartnerJobRequest.serviceCodes = nonPartnerServiceCodes;
            nonPartnerJobRequest.notes = nonPartnerNotes;
            nonPartnerJobRequest.partner = false;
            // quotes must be set to pricing when until futher notice
            nonPartnerJobRequest.status = JOB_REQUEST_STATUS.PRICING;
            jobRequests.push(nonPartnerJobRequest);
        }

        return jobRequests;
    }

    /**
     * @param phoneNumber
     * @deprecated
     */
    public phoneNumberCheck(phoneNumber: any) {
        if (!this.isEmpty(phoneNumber)) {
            let check = phoneNumber.replace(/\D/g, '');
            if (!this.isEmpty(check) && check.length === 10) {
                return true;
            } else {
                return false;
            }
        } else {
            // this is weird to return true here, but i don't want the template to show an error if contactData.phone
            // is empty, and cuz it's required the form can't get submitted without it so it all should work
            return true;
        }
    } // phoneNumberCheck()

    public static phoneNumberCheck(phoneNumber: any) {
        if (!UtilitiesService.isEmpty(phoneNumber)) {
            let check = phoneNumber.replace(/\D/g, '');
            return !UtilitiesService.isEmpty(check) && check.length === 10;
        } else {
            return false;
        }
    } // phoneNumberCheck()

    public static getChecklistItemCategory(item: any): string {
        const green: string = 'green';
        const yellow: string = 'yellow';
        const red: string  = 'red';

        let category: string = '';
        let value: number;
        try {
            value = parseInt(item.value);
        } catch (e) {
            value = null;
        }

        switch (item.type) {
            case 'goodBadUglyNa':
            case 'goodBadUgly':
            case 'yesNoNa':
                if (value === 1) {
                    category = green;
                } else if (value === 2) {
                    category = yellow;
                } else if (value === 3) {
                    category = red;
                }
                break;
            case 'range':
                // check if lower or higher is better
                if (item.goodThreshold > item.badThreshold) {
                    if ((item.goodThreshold <= value) && (value <= item.max)) {
                        category = green;
                    } else if ((item.badThreshold < value) && (value < item.goodThreshold)) {
                        category = yellow;
                    } else if ((item.min <= value) && (value <= item.badThreshold)) {
                        category = red;
                    }
                } else {
                    if ((item.min <= value) && (value <= item.goodThreshold)) {
                        category = green;
                    } else if ((item.goodThreshold < value) && (value < item.badThreshold)) {
                        category = yellow;
                    } else if ((item.badThreshold <= value) && (value <= item.max)) {
                        category = red;
                    }
                }
                break;
            case 'radio':
                // ugh... keeping for legacy purposes
                if (item.name === "Front Windshield") {
                    if (value === 0) {
                        category = green;
                    } else if (value === 5) {
                        category = yellow;
                    } else {
                        category = red;
                    }
                }
                break;
            case 'boolean':
                if (item.value === 'true') {
                    category = green;
                // don't mark invalid values as bad
                } else if (typeof item.value == 'string') {
                    category = red;
                }
            break;
            default:
                // do nothing
        }

        return category;
    } // getChecklistItemCategory()

    static seconds(secs: number) {
        return secs * 1000;
    } // seconds()

    public static setError(errorInfo: any, header: string, message: string, component?: string) {
        errorInfo.error = true;
        errorInfo.header = header;
        errorInfo.message = message;
        errorInfo.component = component;
        return errorInfo;
    } // setError()

    public static isIOS() {
        return navigator.platform === 'iPhone' || navigator.platform === 'iPad' || navigator.platform === 'iPod';
    } // isIOS()

    public static getRandomizeReferralSources() {
        let list = REFERRAL_SOURCES;
        let currentIndex = list.length, temporaryValue, randomIndex;
        while (0 !== currentIndex) {
            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = list[currentIndex];
            list[currentIndex] = list[randomIndex];
            list[randomIndex] = temporaryValue;
        }
        // other is always last
        list.push('Other');
        return list;

    } // randomizeReferralSources()

    generatePassword(): string {
        const numberChars = "0123456789";
        const upperChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const lowerChars = "abcdefghijklmnopqrstuvwxyz";
        const symbols = '@#$!%*?&';
        const passwordLength = 9;
        const allChars = numberChars + upperChars + lowerChars + symbols;
        let randPasswordArray = Array(passwordLength);
        randPasswordArray[0] = numberChars;
        randPasswordArray[1] = upperChars;
        randPasswordArray[2] = lowerChars;
        randPasswordArray[3] = symbols;
        randPasswordArray = randPasswordArray.fill(allChars, 4);
        return this.shuffleArray(randPasswordArray.map( (x) => { return x[Math.floor(Math.random() * x.length)]; })).join('');
    } // generatePassword()

    shuffleArray(array: any[]): any[] {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            const temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
        return array;
    } // shuffleArray()

    getCurrencySymbol(code: string) {
        if (UtilitiesService.isEmpty(code)) {
            return '$';
        }
        return getCurrencySymbol(code, 'narrow');
    } // getCurrencySymbol()

    static totalInCents(amount: number): number {
        return Math.round(amount * 100);
    }

    static cleanObject(obj) {
        let cleanedObj = {};
        for (let key in obj) {
            if (obj[key] !== null && obj[key] !== '') {
                cleanedObj[key] = obj[key];
            }
        }
        return cleanedObj;
    }

}
